import { render, staticRenderFns } from "./material-table.vue?vue&type=template&id=0d925d87&scoped=true"
import script from "./material-table.vue?vue&type=script&setup=true&lang=js"
export * from "./material-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-table.vue?vue&type=style&index=0&id=0d925d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d925d87",
  null
  
)

export default component.exports